import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces, hexToRgbaWithAlpha } from '../theme';
import { borderRadius } from '../styles/mixins';

export const useFooterStyles = createStyles(({ token }) => ({
  footer: {
    height: 24,
    fontWeight: 500,
    ...borderRadius({ size: token.borderRadius, side: 'bottom' }),

    '&:last-child': {
      marginBottom: ThemeSpaces.SPACE_NORM,
    },
  },
  footerDark: {
    backgroundColor: ThemeColors.COLOR_GREY_BLUISH,
    color: ThemeColors.COLOR_WHITE,
  },
  footerLight: {
    backgroundColor: ThemeColors.COLOR_WHITE2,
    color: ThemeColors.COLOR_GREY4,
    boxShadow: `2px 4px 12px ${hexToRgbaWithAlpha(
      ThemeColors.COLOR_GREY_BLUISH,
      0.35
    )}`,
  },
}));
